export const PAYMENT_OPTION_INTENT = { Deposit: 1, Withdraw: 2 };
